import React, { useState } from 'react'
import { useGetGoals } from '../../../redux/human-resources/hook/performance'
import DataTable from '../../../components/datatable'
import { PAGINATION_DEFAULT } from '../../../utils/constants'

const CompanyGoals = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })

  const { data: employeeGoals } = useGetGoals(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Goal Name', 'Start Date', 'Target Date'],
    keys: ['name', 'start_date', 'target_date'],
    mobileHeader: {
      left: {
        title: 'Goal Name',
        key: 'name',
      },
      right: {
        title: 'Start Date',
        key: 'start_date',
      },
    },
  }

  return (
    <DataTable
      data={employeeGoals}
      tableConfig={tableConfig}
      updatePagination={(data) => setPagination(data)}
      tableType={'goals'}
      searchData={true}
    />
  )
}

export default CompanyGoals
